module.exports = __webpack_public_path__ + "static/media/HL8.ab169b22.jpg";